module.exports = __webpack_public_path__ + "media/images/sort-753f05a41e361d825a491166c7b1f810.svg";